import { createSlice } from "@reduxjs/toolkit";

type ShipmentsState = {
  value: any[] | null;
};

const initialState: ShipmentsState = {
  value: null,
};

export const shipments = createSlice({
  name: "shipments",
  initialState,
  reducers: {
    initShipment: (state, action) => {
      state.value = action.payload;
    },

    pushShipmentToPage: (state, action) => {
      const pageNo = action.payload.pageNo;
      
      if (!state.value) {
        state.value = [action.payload.shipments];
      } else {
        if (state.value) {
          state.value[pageNo] = [];

          state.value[pageNo].push(...action.payload.shipments);
        }
      }
    },
  },
});

export const { initShipment, pushShipmentToPage } = shipments.actions;

export default shipments.reducer;
